module.exports = __webpack_public_path__ + "img/miao.1c65a261.png";